export default "__VITE_ASSET__1de57922__"